import React, { useState } from "react";
import { styled } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { CssBaseline, Grid, Paper, Box } from "@mui/material";

// **定制 Tab 样式**
const StyledTab = styled(Tab)(({ theme }) => ({
  backgroundColor: "#f8f6f2",
  textAlign: "center",
  padding: "10px 14px",
  fontSize: "1rem",
  fontWeight: "normal",
  color: "#333",
  fontFamily: "inherit",
  minWidth: "120px", // ✅ 调宽
  "&.Mui-selected": {
    backgroundColor: "#8b0012",
    color: "#fff",
  },
  "&:hover": {
    backgroundColor: "#ddd",
  },
  "@media (max-width: 500px)": {
    fontSize: "0.8rem !important",
    minWidth: "90px !important",
    padding: "8px 12px !important",
  },
}));

// **定制 Paper 样式（指标框）**
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: "1rem",
  textAlign: "center",
  backgroundColor: "#fff",
  border: "1px solid #ddd",
  boxShadow: "none",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1rem",
  fontWeight: "normal",
  fontFamily: "inherit",
  "@media (max-width: 500px)": {
    fontSize: "0.8rem !important",
    padding: "0.8rem !important",
  },
}));

// **三类区域指标数据**
const nationalData = ["GDP"];
const ZhusanjiaoData = ["GDP"];
const guangShenData = [
  "GDP",
  "规上工业增加值",
  "全社会固定资产投资额",
  "社会消费品零售总额",
  "本外币各项贷款余额",
  "出口额",
  "进口额",
];

export default function PredictionIndicators() {
  const [value, setValue] = useState(0);
  const indicatorData = [nationalData, ZhusanjiaoData, guangShenData];

  return (
    <React.Fragment>
      <CssBaseline />
      <div className="intro">
        <h2>
          <a>
            {" 指标列表 "}
            <small>Indicators</small>
          </a>
        </h2>
        <Box sx={{ display: "flex", maxWidth: "1000px", margin: "0 auto" }}>
          {/* **左侧 Tabs** */}
          <Tabs
            orientation="vertical"
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            sx={{
              flexShrink: 0,
              minWidth: "120px",
              width: "140px",
              marginRight: "10px",
              fontFamily: "inherit",
              "& .MuiTabs-indicator": {
                width: "3px",
              },
              "@media (max-width: 500px)": {
                minWidth: "80px !important",
                width: "80px !important",
              },
            }}
          >
            <StyledTab label="全国" />
            <StyledTab label="珠三角" />
            <StyledTab label="广深" />
          </Tabs>

          {/* **右侧指标列表** */}
          <Box sx={{ flex: 1 }}>
            <Grid container spacing={1}>
              {indicatorData[value].map((item, index) => (
                <Grid item xs={6} sm={4} md={4} key={index}>
                  <StyledPaper>{item}</StyledPaper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </div>
    </React.Fragment>
  );
}
